import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IDossier } from '@features/mes-financements/models/dossier.model';
import { DossierSearchCriteria } from '@features/mes-financements/features/mes-financements-recherche/models/recherche-request';
import { MesFinancementsConfig } from '@features/mes-financements/config/mes-financements.config';
import { PaginatedResponse } from '@shared/components/model/paginated-response.model';
import { DemandeRemboursementConfig } from '@features/demande-remboursement/demande-remboursement/config/demande-remboursement.config';
import { FinancementRechercheExportRequest } from '../features/mes-financements-recherche/models/financement-recherche-export-request';

@Injectable({
  providedIn: 'root',
})
export class MesFinancementsService {
  constructor(private httpClient: HttpClient) { }

  getDossiers(query: DossierSearchCriteria): Observable<PaginatedResponse<IDossier>> {
    return this.httpClient.post<PaginatedResponse<IDossier>>(
      MesFinancementsConfig.listeDossiers,
      query,
    );
  }

  getDossiersExport(query: FinancementRechercheExportRequest): Observable<HttpResponse<Blob>> {
    return this.httpClient.post(
      MesFinancementsConfig.listeDossiersExport,
      query,
      {
        observe: 'response',
        responseType: 'blob',
      }
    );
  }

  getStagiairesExport(query: FinancementRechercheExportRequest): Observable<HttpResponse<Blob>> {
    return this.httpClient.post(
      MesFinancementsConfig.listeStagiairesExport,
      query,
      {
        observe: 'response',
        responseType: 'blob',
      }
    );
  }

  updatePaymentRecipient(identifiantTechniqueDossier: string): Observable<any> {
    return this.httpClient.put(
      `${DemandeRemboursementConfig.baseURL}dossier/${identifiantTechniqueDossier}/subroge`,
      {},
    );
  }
}
